
// shared
import { shared, generalProps } from './shared';

// types
import { Props, Context } from '../../types';

// vue
import { defineComponent } from 'vue';

// components
import Skeleton from '../skeleton/index.vue';

export default defineComponent({
    name: 'trading-view-mobile',
    props: generalProps,
    components: {
        Skeleton,
    },
    setup(props, context: Context) {

        return {
            ...shared(props as Readonly<Props>, context),
        };
    },
});
